import { render, staticRenderFns } from "./SexyVideo.vue?vue&type=template&id=6ef6d543&scoped=true"
import script from "./SexyVideo.vue?vue&type=script&lang=js"
export * from "./SexyVideo.vue?vue&type=script&lang=js"
import style0 from "./SexyVideo.vue?vue&type=style&index=0&id=6ef6d543&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef6d543",
  null
  
)

export default component.exports